import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Image */}
          <div className="lg:w-1/2 w-full">
            <div className="w-full h-[320px] md:h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20flat%20lay%20with%20open%20notebook%20showing%20organized%20product%20notes%20alongside%20curated%20lifestyle%20accessories%20including%20watch%20and%20small%20leather%20goods%20on%20warm%20cream%20linen%20texture%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography%2C%20elevated%20neutral%20aesthetic%2C%20harmonious%20minimal%20composition&width=800&height=600&seq=about-vigorbuy-v3&orientation=landscape"
                alt="What is VigorBuy Spreadsheet - product organization resource guide"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="lg:w-1/2 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-4">
              About The Spreadsheet
            </span>
            <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-5 leading-tight">
              What Is VigorBuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              VigorBuy Spreadsheet helps users organize products, compare options, and discover new
              items more efficiently. Instead of searching through endless listings, the spreadsheet
              format presents curated product information in a clean, structured layout that makes
              browsing and decision-making faster and more intuitive.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Whether you are looking for the latest sneakers, browsing seasonal hoodies, or
              comparing accessory prices, the VigorBuy Spreadsheet brings everything together in one
              accessible resource. Updated weekly, it reflects the most current product availability
              and category changes.
            </p>
            <Link
              to="/article/vigorbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}